/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".matLabelcls[_ngcontent-%COMP%]{font-weight:400!important}.padding-left-tdlg[_ngcontent-%COMP%]{padding-left:30px!important}  .mat-checkbox-disabled .mat-checkbox-frame{border-color:#d6d6d6!important}button[_ngcontent-%COMP%]:disabled{opacity:.5}.width-10[_ngcontent-%COMP%]{width:10%}.width-15[_ngcontent-%COMP%]{width:15%}.width-20[_ngcontent-%COMP%]{width:20%}.hidden-image[_ngcontent-%COMP%]{opacity:0}"];
export { styles as styles };
